import client from '../client'
import { VehicleType } from '../enums'

export const getSectionsStateKey = `${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/Vehicles/GetDetailsSectionsState`

export async function getSectionsState({ vehicleId }) {
  const params = new URLSearchParams({ vehicleId })

  return client(`${getSectionsStateKey}?${params.toString()}`).then((res) => {
    const normalizedResult = {
      ...res,
      totalSteps: res.vehicleType != VehicleType.DealerInventory ? 8 : 4,
      sectionStatuses: {
        build: {
          completed: res.buildDetailsSectionCompleted,
          visible: true,
          label: 'The Build',
          stepNumber: 1,
          nextStep: 'basics',
        },
        basics: {
          completed: res.basicDetailsSectionCompleted,
          visible: true,
          label: 'The Basics',
          stepNumber: 2,
          nextStep: res.vehicleType != VehicleType.DealerInventory ? 'ownership' : 'photos',
        },
        ownership: {
          completed: res.ownershipDetailsSectionCompleted,
          visible: res.vehicleType != VehicleType.DealerInventory,
          label: 'Ownership',
          stepNumber: 3,
          nextStep: 'mechanical',
        },
        mechanical: {
          completed: res.mechanicalDetailsSectionCompleted,
          visible: res.vehicleType != VehicleType.DealerInventory,
          label: 'Mechanical',
          stepNumber: 4,
          nextStep: 'photos',
        },
        photos: {
          completed: res.photoSectionCompleted,
          visible: true,
          label: 'Photos',
          stepNumber: res.vehicleType != VehicleType.DealerInventory ? 5 : 3,
          nextStep: res.vehicleType != VehicleType.DealerInventory ? 'interior' : 'comments',
        },
        interior: {
          completed: res.interiorDetailsSectionCompleted,
          visible: res.vehicleType != VehicleType.DealerInventory,
          label: 'Interior',
          stepNumber: 6,
          nextStep: 'exterior',
        },
        exterior: {
          completed: res.exteriorDetailsSectionCompleted,
          visible: res.vehicleType != VehicleType.DealerInventory,
          label: 'Exterior',
          stepNumber: 7,
          nextStep: 'comments',
        },
        comments: {
          completed: res.commentsSectionCompleted,
          visible: true,
          label: res.vehicleType == VehicleType.Consumer ? 'Comments' : 'Description',
          stepNumber: res.vehicleType != VehicleType.DealerInventory ? 8 : 4,
        },
      },
    }

    normalizedResult.completedCount = Object.entries(normalizedResult.sectionStatuses).filter(
      ([, status]) => status.completed,
    ).length

    return normalizedResult
  })
}
